import React, { Component } from 'react'
import URLUtils from '../../util/URLUtils'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import LoginWithEmailUI from './LoginWithEmailUI.js'

class LoginWithEmailSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: [],
      submitted: false,
      socialLoginUrl: null,
      // email
      email: '',
      emailError: null,
      // password
      password: '',
      passwordError: null,
      showPasswordField: false
    }
  }

  render() {
    return (
      <LoginWithEmailUI
        context={this.props.context}
        messageList={this.state.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        // email
        email={this.state.email}
        onEmailChange={this.onEmailChange}
        emailError={this.state.emailError}
        setEmailError={this.setEmailError}
        // password
        password={this.state.password}
        onPasswordChange={this.onPasswordChange}
        passwordError={this.state.passwordError}
        setPasswordError={this.setPasswordError}
        showPasswordField={this.state.showPasswordField}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
    this.getSocialLoginUrl(context)
  }

  onEmailChange = (event) => {
    this.setState({email: event.target.value})
  }

  onPasswordChange = (event) => {
    this.setState({password: event.target.value})
  }

  setEmailError = (error) => {
    this.setState({emailError: error})
  }

  setPasswordError = (error) => {
    this.setState({passwordError: error})
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    if (!this.state.showPasswordField) {
      let cacheManager = new CacheManager({
        // slash added at the end because Spring removes . extension
        resource: `/api/pub/user/identity-provider/${this.state.email}/`,
        cacheKey: CacheKeys.IdentityProvider(this.state.email),
        callback: this.onGetIdentityProviderCallback,
        ttlInSecs: 600
      })
      cacheManager.getObject2(this.props.context)
    }
    else {
      RestApiUtils.post(this.props.context,
        `/api/pub/loginWithEmail`,
        this.onLoginCallback, {
          email: this.state.email,
          password: this.state.password
        }
      )
    }
  }

  onGetIdentityProviderCallback = response => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        this.setEmailError(error.message)
      })
      this.setErrorList(errorList)
      this.setState({showPasswordField: false})
      return;
    }

    this.setErrorList([])

    let provider = response.identityProvider
    switch (provider) {
      case "google":
        this.setState({successMsg: response.success})
        setTimeout(() => {
          window.location = this.state.socialLoginUrl.googleLoginUrl
        }, 2000);
        break;
      case "facebook":
        this.setState({successMsg: response.success})
        setTimeout(() => {
          window.location = this.state.socialLoginUrl.fbLoginUrl
        }, 2000);
        break;
      default:
        this.setState({showPasswordField: true})
    }
  }

  onLoginCallback = (response) => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'email':
            this.setEmailError(error.message)
            break;
          case 'password':
            this.setPasswordError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({successMsg: response.success})

    if (errorList.length === 0) {
      this.props.context.onLogin(response.session)
    }
  }

  getSocialLoginUrl(context) {
    let cacheManager = new CacheManager({
      resource: '/api/pub/socialLoginUrl',
      cacheKey: CacheKeys.SocialLoginUrl,
      callback: this.getSocialLoginUrlCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, {baseUrl: URLUtils.getBaseURL()})
  }

  getSocialLoginUrlCallback = (response) => {
    this.setState({socialLoginUrl: response})
  }

  getMessages(context) {
    let arr = [
      'c_email',
      'c_password',
      'c_login',
      'c_next',
      'c_forgot_passwd_help',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pub_login_w_em', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default LoginWithEmailSF
